import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { reportNavigationVitals } from '../reportWebVitals';

/**
 * Custom hook to track Web Vitals on navigation events
 * This hook automatically reports Web Vitals metrics whenever the user
 * navigates to a different route in the application
 */
export const useWebVitalsTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Small delay to let the page render before measuring
    const timer = setTimeout(() => {
      console.log(`📍 Navigation detected: ${location.pathname}`);
      reportNavigationVitals();
    }, 100);

    return () => clearTimeout(timer);
  }, [location.pathname]);
};

export default useWebVitalsTracking;
